import request from '@/utils/request'
import axios from 'axios'
import { getUuid, uuid } from '@/utils'
import dayjs from 'dayjs'
// 物料类别（产品类别）
export const productCategory = params => {
  return request({
    url: `/hhxc-basic/api/v1/kdMaterialGroup/treeList`,
    method: 'post',
    data: params,
  })
}
// 最后更新时间
export async function apiLastUpdataTime(params) {
  return request({
    url: '/hhxc-basic/api/v1/kingDee/getUpdateTime',
    method: 'get',
    params,
  })
}

// 最后更新时间(根据 id来查询)
export async function apiUpdataTimeFromID(params) {
  return request({
    url: `/hhxc-sync-data/api/v1/dataUpdateTime/getById/${params.id}`,
    method: 'POST',
  })
}

// 获取国家列表(站点)
export async function apiMarketplace(params) {
  return request({
    // url: `/hhxc-basic/api/v1/sellerMarketplace/marketplace`,
    // method: 'get',
    // params,
    url: `/hhxc-basic/api/v1/akSellers/marketplaceList`,
    method: 'post',
    data: params,
  })
}

// 获取所有店铺列表
export async function apiSellerMarketplace(params) {
  return request({
    url: `/hhxc-sync-data/api/v1/akSellers/sellerList`,
    method: 'post',
    data: params,
  })
}

// 获取项目列表（全部，不分页）
export async function apiProjectALL(params) {
  return request({
    url: `/hhxc-basic/api/v1/project/list`,
    method: 'get',
    params,
  })
}

// 字段查询（即数字参数获取不同的名称）
export function apiGetDifferentInfo(paramArray) {
  return request({
    url: `/hhxc-admin/api/v1/dictItem`,
    method: 'get',
    params: {
      dictCode: paramArray[0] || '',
      name: paramArray[1] || '',
    },
  })
}
export const getOssSign = async params => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/HairReport/doGet`, method: 'get', params })
}

export const uploadOss = async (data, file) => {
  const _uuid = getUuid()
  const { host, policy, accessid, signature, dir } = data
  const fileTypeArr = file.name.split('.')
  const fileType = file.name.split('.')[fileTypeArr.length - 1]
  const fileName = dir + _uuid + '.' + fileType
  const formData = new FormData()
  formData.append('key', fileName)
  formData.append('OSSAccessKeyId', accessid)
  formData.append('success_action_status', '200')
  formData.append('signature', signature)
  formData.append('callback', data['callback'])
  formData.append('policy', policy)
  formData.append('file', file)
  const res = await axios.post(host, formData)
  return res?.data || {}
}

export const aiSse = async params => {
  return request({
    url: '/hhxc-business/v1/businessKnowledgeOssFile/streamChat',
    method: 'get',
    params,
    responseType: 'stream',
  })
}
